import React, { useState, useEffect } from "react";
import { publisherUrl } from "./XBEcard";
export function XBEpaBanner({ filters }) {
  return (
    <div className="l_block">
      <div className="l_content l_content--xbe">
        <div className="l_content_center">
          <div className="l_width_1160">
            <div className="l_paddings_l">
              <div className="x_cat_bannertext">
                <div className="x_cat_hero-cont">
                  <div className="l_line">
                    <h1 className="t_hero_h1 t_hero_h1--2nd">
                      GET IT ALL IN ONE PLACE WITH
                      <br />
                      <span className="v-c_blue">XSOLLA PUBLISHER ACCOUNT</span>
                      <br />
                    </h1>
                  </div>
                  <div className="l_line">
                    <h3 className="t_hero_h2 t_hero_h2--publ">
                      Explore the full suite of Xsolla products to learn every
                      way that our intuitive tools and services can help you
                      distribute, promote, sell, and accept payments for your
                      games.
                      <br />
                    </h3>
                  </div>
                  <div className="l_paddings_s l_paddings_s--top">
                    <div className="l_line l_line--flex l_line--noflex--4">
                      <a
                        href={publisherUrl(filters)}
                        className="xbe_card_cta xbe_card_cta--main xbe_card_cta--main--pa"
                      >
                        Get started
                      </a>

                      <a
                        href="https://apps.apple.com/us/app/xsolla-business-engine/id1491307098"
                        target="_blank"
                        className="xbe_card_cta xbe_card_cta--main xbe_card_cta--appstore w-inline-block"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="l_block_bg l_block_bg--pa">
          <div className="x_home_top_pic x_home_top_pic--xbe x_home_top_pic--xbe--r" />
        </div>
        <div className="x_home_top_pic x_home_top_pic--xbe x_home_top_pic--xbe--r" />
      </div>

      <div className="l_block_bg l_block_bg--xbe--grad" style={{ zIndex: 0 }}>
        <div className="l_block_bg_pa" />
      </div>
    </div>
  );
}
